import axios from 'axios';
import { BASE_URL } from '../utils/constants';

interface ProblemStatusResponse {
  status: 'completed' | 'pending' | 'error';
  problem_id?: number;
  context?: string;
  programming_concepts?: string;
  problem_statement?: string;
  test_driver?: string;
}

export const HandleProblem = {
  generateProblem: async (user_id: number, session_id: string, is_study_participant: boolean, context: string, concepts: string): Promise<any> => {
    try {
      const response = await axios.post(`${BASE_URL}/problemrequest/`, {
        user_id,
        session_id,
        is_study_participant,
        context,
        programming_concepts: concepts
      });
  
      return response.data;
    } catch (error) {
      console.error('Error generating problem:', error);
      throw error;
    }
  },

  checkProblemStatus: async (requestId: number): Promise<any> => {
    try {
      const response = await axios.get(`${BASE_URL}/problemrequest/${requestId}/check_status/`);
      return response.data;
    } catch (error) {
      console.error('Error checking problem status:', error);
      if (axios.isAxiosError(error) && error.response?.data) {
        throw new Error(error.response.data.error || 'An error occurred while checking problem status');
      } else {
        throw new Error('An unexpected error occurred while checking problem status');
      }
    }
  },

  pollProblemStatus: async (
    requestId: number, 
    onSuccess: (status: ProblemStatusResponse) => void,
    onPending: () => void,
    onError: () => void
  ): Promise<void> => {
    try {
      const status = await HandleProblem.checkProblemStatus(requestId);
      
      if (status.status === 'completed') {
        onSuccess(status);
      } else if (status.status === 'pending') {
        onPending();
        // Recursively poll after 5 seconds
        setTimeout(() => HandleProblem.pollProblemStatus(requestId, onSuccess, onPending, onError), 5000);
      } else {
        onError();
      }
    } catch (error) {
      console.error('Error polling problem status:', error);
      onError();
    }
  }
};
